import React from 'react';
import styles from './Header.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const Header = ({className, text}) => {
  return (
    <h1 className={`${cx('Header')} ${className}`}>{text}</h1>
  );
};

export default Header;